import { createContext } from "react";

export const NavigatorContext = createContext();